import { Link } from 'react-router-dom'
import { Screen } from '@/ui/Screen'
import { AdminLockButton } from '@/features/admin/AdminLockButton'

export function NotFoundScreen() {
  return (
    <Screen title="Not found" subtitle="That page doesn't exist." action={<AdminLockButton />}>
      <Link
        to="/"
        className="inline-flex min-h-touch items-center rounded-2xl bg-brand-600 px-6 font-semibold text-white"
      >
        Back to workflows
      </Link>
    </Screen>
  )
}
